import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import SocialIcon from './SocialIcon';
import { api } from '../lib/api';

const SOCIALS = [
  { key: 'whatsapp_url', name: 'whatsapp', label: 'WhatsApp' },
  { key: 'instagram_url', name: 'instagram', label: 'Instagram' },
  { key: 'discord_url', name: 'discord', label: 'Discord' },
  { key: 'telegram_url', name: 'telegram', label: 'Telegram' },
  { key: 'youtube_url', name: 'youtube', label: 'YouTube' },
  { key: 'twitter_url', name: 'x', label: 'X (Twitter)' },
  { key: 'facebook_url', name: 'facebook', label: 'Facebook' },
];

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.settings().then(setSettings).catch(() => {});
  }, []);

  const socials = SOCIALS.filter((s) => settings?.[s.key]);

  return (
    <footer className="bg-black border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-4 text-sm text-[#9e9e9e] leading-relaxed max-w-xs">
              India's home for competitive BGMI & Free Fire tournaments. Compete. Win. Earn real money.
            </p>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#8a8a8a] mb-5">Company</h4>
            <ul className="space-y-3">
              <li><Link data-testid="footer-about-link" to="/about" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">About</Link></li>
              <li><Link data-testid="footer-contact-link" to="/#contact" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">Contact</Link></li>
              <li><Link data-testid="footer-faq-link" to="/#faq" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">FAQ</Link></li>
              <li><Link data-testid="footer-press-link" to="/press" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">Press Kit</Link></li>
              <li><Link data-testid="footer-payouts-link" to="/payouts" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">Payout Proof</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#8a8a8a] mb-5">Legal</h4>
            <ul className="space-y-3">
              <li><Link data-testid="footer-privacy-link" to="/privacy-policy" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">Privacy Policy</Link></li>
              <li><Link data-testid="footer-terms-link" to="/terms" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">Terms & Conditions</Link></li>
              <li><Link data-testid="footer-refund-link" to="/refund-policy" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">Refund Policy</Link></li>
              <li><Link data-testid="footer-community-link" to="/community-guidelines" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">Community Guidelines</Link></li>
              <li><Link data-testid="footer-admob-link" to="/admob" className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors">AdMob Compliance</Link></li>
              {settings?.contact_email_1 && (
                <li>
                  <a
                    data-testid="footer-delete-account-link"
                    href={`mailto:${settings.contact_email_1}?subject=Account%20Deletion%20Request`}
                    className="text-sm text-[#c9c9c9] hover:text-[#e8173a] transition-colors"
                  >
                    Delete Account
                  </a>
                </li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#8a8a8a] mb-5">Connect</h4>
            {socials.length > 0 ? (
              <div className="flex flex-wrap gap-3" data-testid="footer-socials">
                {socials.map((s) => (
                  <a
                    key={s.key}
                    data-testid={`footer-social-${s.name}`}
                    href={settings[s.key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="w-10 h-10 rounded-lg bg-[#1a1f2e] border border-white/5 flex items-center justify-center text-[#9e9e9e] hover:text-white hover:border-[#e8173a]/50 hover:bg-[#e8173a]/10 transition-all duration-300"
                  >
                    <SocialIcon name={s.name} className="w-[18px] h-[18px]" />
                  </a>
                ))}
              </div>
            ) : (
              <p className="text-sm text-[#5c5c5c]">Socials coming soon.</p>
            )}
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <Logo />
          <p className="text-xs text-[#5c5c5c]" data-testid="footer-copyright">
            Copyright 2026 KROY Esports. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
